// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var _a;
import { ETemplateType } from "./templates";
export var ReportActions;
(function (ReportActions) {
    ReportActions["EDIT"] = "edit";
    ReportActions["DELETE"] = "delete";
    ReportActions["GENERATE"] = "generate";
    ReportActions["PREVIEW"] = "preview";
    ReportActions["GENERATE_SCHEDULED"] = "generate-scheduled";
})(ReportActions || (ReportActions = {}));
export var EReportType;
(function (EReportType) {
    EReportType["BALLOT_RECEIPT"] = "BALLOT_RECEIPT";
    EReportType["BALLOT_IMAGES"] = "BALLOT_IMAGES";
    EReportType["VOTE_RECEIPT"] = "VOTE_RECEIPT";
    EReportType["ELECTORAL_RESULTS"] = "ELECTORAL_RESULTS";
    EReportType["MANUAL_VERIFICATION"] = "MANUAL_VERIFICATION";
    EReportType["STATISTICAL_REPORT"] = "STATISTICAL_REPORT";
    EReportType["OVCS_EVENTS"] = "OVCS_EVENTS";
    EReportType["AUDIT_LOGS"] = "AUDIT_LOGS";
    EReportType["ACTIVITY_LOGS"] = "ACTIVITY_LOGS";
    EReportType["STATUS"] = "STATUS";
    EReportType["OVCS_INFORMATION"] = "OVCS_INFORMATION";
    EReportType["LIST_OF_OVERSEAS_VOTERS"] = "LIST_OF_OVERSEAS_VOTERS";
    EReportType["OV_WHO_VOTED"] = "OV_WHO_VOTED";
    EReportType["OVCS_STATISTICS"] = "OVCS_STATISTICS";
    EReportType["PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION"] = "PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION";
    EReportType["PRE_ENROLLED_OV_BUT_DISAPPROVED"] = "PRE_ENROLLED_OV_BUT_DISAPPROVED";
    EReportType["INITIALIZATION_REPORT"] = "INITIALIZATION_REPORT";
    EReportType["TRANSMISSION_REPORT"] = "TRANSMISSION_REPORT";
    EReportType["OV_TURNOUT_PERCENTAGE"] = "OV_TURNOUT_PERCENTAGE";
    EReportType["OV_TURNOUT_PER_ABOARD_STATUS_SEX"] = "OV_TURNOUT_PER_ABOARD_STATUS_SEX";
    EReportType["OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE"] = "OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE";
    EReportType["OV_PRE_ENROLLED_APPROVED"] = "OV_PRE_ENROLLED_APPROVED";
    EReportType["OV_NOT_YET_PRE_ENROLLED_LIST"] = "OV_NOT_YET_PRE_ENROLLED_LIST";
    EReportType["OV_WITH_VOTING_STATUS"] = "OV_WITH_VOTING_STATUS";
    EReportType["OV_NOT_YET_PRE_ENROLLED_NUMBER"] = "OV_NOT_YET_PRE_ENROLLED_NUMBER";
})(EReportType || (EReportType = {}));
export var EReportElectionPolicy;
(function (EReportElectionPolicy) {
    EReportElectionPolicy["ELECTION_REQUIRED"] = "ELECTION_REQUIRED";
    EReportElectionPolicy["ELECTION_ALLOWED"] = "ELECTION_ALLOWED";
    EReportElectionPolicy["ELECTION_NOT_ALLOWED"] = "ELECTION_NOT_ALLOWED";
})(EReportElectionPolicy || (EReportElectionPolicy = {}));
export var reportTypeConfig = (_a = {},
    _a[EReportType.BALLOT_RECEIPT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.BALLOT_RECEIPT,
    },
    _a[EReportType.VOTE_RECEIPT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.VOTE_RECEIPT,
    },
    _a[EReportType.BALLOT_IMAGES] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.BALLOT_IMAGES,
    },
    _a[EReportType.ELECTORAL_RESULTS] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.ELECTORAL_RESULTS,
    },
    _a[EReportType.MANUAL_VERIFICATION] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.MANUAL_VERIFICATION,
    },
    _a[EReportType.STATISTICAL_REPORT] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.STATISTICAL_REPORT,
    },
    _a[EReportType.OVCS_EVENTS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OVCS_EVENTS,
    },
    _a[EReportType.AUDIT_LOGS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.AUDIT_LOGS,
    },
    _a[EReportType.ACTIVITY_LOGS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.ACTIVITY_LOGS,
    },
    _a[EReportType.STATUS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.STATUS,
    },
    _a[EReportType.OVCS_STATISTICS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OVCS_STATISTICS,
    },
    _a[EReportType.OVCS_INFORMATION] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.OVCS_INFORMATION,
    },
    _a[EReportType.LIST_OF_OVERSEAS_VOTERS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.LIST_OF_OVERSEAS_VOTERS,
    },
    _a[EReportType.OV_WHO_VOTED] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_WHO_VOTED,
    },
    _a[EReportType.PRE_ENROLLED_OV_BUT_DISAPPROVED] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.PRE_ENROLLED_OV_BUT_DISAPPROVED,
    },
    _a[EReportType.PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION,
    },
    _a[EReportType.INITIALIZATION_REPORT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.INITIALIZATION_REPORT,
    },
    _a[EReportType.TRANSMISSION_REPORT] = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.TRANSMISSION_REPORT,
    },
    _a[EReportType.OV_TURNOUT_PERCENTAGE] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
        associatedTemplateType: ETemplateType.OV_TURNOUT_PERCENTAGE,
    },
    _a[EReportType.OV_TURNOUT_PER_ABOARD_STATUS_SEX] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_TURNOUT_PER_ABOARD_STATUS_SEX,
    },
    _a[EReportType.OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_TURNOUT_PER_ABOARD_STATUS_SEX_PERCENTAGE,
    },
    _a[EReportType.OV_PRE_ENROLLED_APPROVED] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_PRE_ENROLLED_APPROVED,
    },
    _a[EReportType.OV_NOT_YET_PRE_ENROLLED_LIST] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_NOT_YET_PRE_ENROLLED_LIST,
    },
    _a[EReportType.OV_WITH_VOTING_STATUS] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_WITH_VOTING_STATUS,
    },
    _a[EReportType.OV_NOT_YET_PRE_ENROLLED_NUMBER] = {
        actions: [
            ReportActions.EDIT,
            ReportActions.DELETE,
            ReportActions.PREVIEW,
            ReportActions.GENERATE,
            ReportActions.GENERATE_SCHEDULED,
        ],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_NOT_ALLOWED,
        associatedTemplateType: ETemplateType.OV_NOT_YET_PRE_ENROLLED_NUMBER,
    },
    _a.default = {
        actions: [ReportActions.EDIT, ReportActions.DELETE, ReportActions.PREVIEW],
        templateRequired: false,
        electionPolicy: EReportElectionPolicy.ELECTION_REQUIRED,
    },
    _a);
export var EGenerateReportMode;
(function (EGenerateReportMode) {
    EGenerateReportMode["REAL"] = "REAL";
    EGenerateReportMode["PREVIEW"] = "PREVIEW";
})(EGenerateReportMode || (EGenerateReportMode = {}));
